export const formatDateAndTime = (timestamp: string) => {
  const date = new Date(timestamp);
  const formattedDate = date.toLocaleString('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC',
  });
  const lastCommaIndex = formattedDate.lastIndexOf(',');

  let result = formattedDate;
  if (lastCommaIndex !== -1) {
    result = formattedDate.slice(0, lastCommaIndex) + formattedDate.slice(lastCommaIndex + 1);
  }
  return result;
};
